// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2w7UW","footer":"styles_footer__9MhmJ","passCodeTooltip":"styles_passCodeTooltip__2BxOT"};